import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { DelayMarketplaceFulfillmentActionStep } from "@redotech/redo-flows-common/oms/actions";
import { formatFulfillmentNotificationReleaseTime } from "@redotech/redo-fulfillment-group-common/marketplace-fulfillment-settings";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { InfoTooltip } from "@redotech/redo-web/arbiter-components/tooltip/info-tooltip";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const DelayMarketplaceFulfillmentInput = memo(
  function DelayMarketplaceFulfillmentInput({
    step,
    setStep,
  }: {
    step: PartialWithRequiredType<DelayMarketplaceFulfillmentActionStep>;
    setStep: (
      step: PartialWithRequiredType<DelayMarketplaceFulfillmentActionStep>,
    ) => void;
  }) {
    const team = useRequiredContext(TeamContext);
    const notificationReleaseTime = formatFulfillmentNotificationReleaseTime(
      team.settings.outboundLabels?.fulfillmentNotificationReleaseHour,
    );
    const marketplaceNotificationTimingTooltip = `The marketplace will be notified at ${notificationReleaseTime} in your store's time zone on the fulfillment date.`;
    const setDelayDays = useHandler((delayDays: number) => {
      setStep({ ...step, delayDays: Math.floor(delayDays) });
    });

    return (
      <Flex align="center" gap="xs">
        <RedoIncrementDecrement
          min={1}
          setValue={setDelayDays}
          size="small"
          step={1}
          suffix={step.delayDays === 1 ? "day" : "days"}
          value={step.delayDays}
        />
        <InfoTooltip
          boxSize={16}
          tooltip={{ title: marketplaceNotificationTimingTooltip }}
        />
      </Flex>
    );
  },
);
